export default __webpack_public_path__ + "alberta-pharmacy.e69ecc50a436f8b8f406.svg";